import React, { useCallback, useEffect, useState } from "react";
import * as RB from "react-bootstrap";
import DataTable from "react-data-table-component";
import * as utils from "../../../Utils/comman";
import { useDispatch, useSelector } from "react-redux";
import {
  AddCircle,
  ArrowLeft,
  DocumentDownload,
  Edit2,
  Eye,
  Trash,
} from "iconsax-react";
import DatePicker from "react-datepicker";

import CustomPagination from "../../../Utils/CustomPagination";
import moment from "moment/moment";

function Listing(props) {
  const statusOptions = [
    { value: "DISTRIBUTION_NETWORK", label: "Send to Dealer" },
    { value: "APPROVED_CHANNEL_PARTNER", label: "Approved by Channel Partner" },
    { value: "REJECTED_CHANNEL_PARTNER", label: "Rejected by Channel Partner" },
    { value: "COMPLETED", label: "Completed" },
    { value: "INVOICE_UPDATED", label: "Invoice Updated" },
  ];
  const [reset, setReset] = useState(false);
  const [orderList, setOrderalist] = useState([]);
  const [filters, setFilters] = useState({
    orderNo: "",
    orderDateRange: [null, null],
    status: "",
    retailerId: "",
  });

  const [page, setPage] = useState(1);
  const countPerPage = 10;
  const primaryMenuRes = useSelector(
    (state) => state?.primaryMenu?.primaryMenu?.permissions
  );
  const [retailer, setRetailer] = useState([]);
  useEffect(() => {
    getOrder();
    getQuotationList();
  }, []);

  const getOrder = () => {
    const vendorType = props?.heading;
    const vendorId = props?.rowData?.id;

    if (!vendorType || !vendorId) return;

    const queryParams = new URLSearchParams({
      page,
      per_page: countPerPage,
      vendor_type: vendorType,
      vendor_id: vendorId,
    });

    if (filters.orderNo) queryParams.append("order_no", filters.orderNo);
    if (filters.status) queryParams.append("status", filters.status);
    if (filters.retailerId) queryParams.append("retailer", filters.retailerId);

    const [startDate, endDate] = filters.orderDateRange;
    if (startDate && endDate) {
      queryParams.append(
        "order_date[from]",
        moment(startDate).format("YYYY-MM-DD")
      );
      queryParams.append(
        "order_date[to]",
        moment(endDate).format("YYYY-MM-DD")
      );
    }

    const url = `/retailer/order/list?${queryParams.toString()}`;

    utils
      .callAPI("get", url)
      .then((res) => {
        setOrderalist(res ?? []);
        setReset(false);
      })
      .catch(() => {
        setOrderalist([]);
      });
  };

  const getQuotationList = (filters) => {
    const bodyFormData = new FormData();

    bodyFormData.append("userId", "");
    bodyFormData.append("id", "");
    bodyFormData.append("vendor_type", "Retailer");
    bodyFormData.append("page", 0);
    bodyFormData.append("per_page", 0);
    bodyFormData.append("cancelstatus", "1");

    bodyFormData.append("company_name", "");
    bodyFormData.append("state", "");
    bodyFormData.append("city", "");
    bodyFormData.append("district", "");
    bodyFormData.append("sp", "");

    utils
      .callAPI("post", `/sales/getsalesFormList`, bodyFormData)
      .then((res) => {
        if (typeof res !== "undefined") {
          setRetailer(res?.result);
        } else {
          setRetailer([]);
        }
      })
      .catch((err) => {
        setRetailer([]);
      });
  };

  const handleBackClick = () => {
    const propdata = {
      mode: "list",
    };
    props.onChange(propdata);
  };

  const columns = [
    {
      name: "Order No.",
      selector: (row) => row.order_no,
      width: "180px",
    },
    ...(props.heading === "Retailer"
      ? [
          {
            name: (
              <>
                Retailer <br />
              </>
            ),
            selector: (row) => row.retailer_info?.companyName || "-",
          },
        ]
      : []),
    {
      name: "Order Date",
      selector: (row) => row.order_date,
    },
    {
      name: "Status",
      selector: (row) => row.status_name,
    },
    {
      name: "Action",
      center: true,
      cell: (row) => (
        <>
          <RB.Button
            className="btn-flat ms-1"
            title="View"
            onClick={handleView(row)}
          >
            <Eye />
          </RB.Button>
        </>
      ),
    },
  ];

  const handleView = useCallback((row) => async () => {
    const propdata = {
      mode: "orderDetail",
      rowData: props?.rowData,
    };
    props?.setOrderDetail(row);
    props.onChange(propdata);
  });

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleDateRangeChange = (range) => {
    setFilters((prev) => ({
      ...prev,
      orderDateRange: range,
    }));
  };

  useEffect(() => {
    if (reset) {
      getOrder();
    }
  }, [reset]);
  return (
    <>
      <div className="section-body">
        <RB.Card className="card shadow">
          <RB.Card.Header>
            <h4>{`${props?.rowData?.companyName} Order Listing`}</h4>
            <div className="card-header-action">
              <RB.Button
                className="btn btn-primary me-2"
                onClick={handleBackClick}
              >
                Back
              </RB.Button>
            </div>
          </RB.Card.Header>
          <RB.Card.Body>
            <RB.Row className="align-items-end flex-wrap g-2">
              <RB.Col xs="auto">
                <RB.Form.Label>Order No.</RB.Form.Label>
                <RB.Form.Control
                  type="text"
                  name="orderNo"
                  value={filters.orderNo}
                  onChange={handleFilterChange}
                  style={{ height: "auto" }}
                />
              </RB.Col>

              {["Distributor", "Dealer"].includes(props.heading) && (
                <RB.Col xs="auto">
                  <RB.Form.Label>Retailer</RB.Form.Label>
                  <RB.Form.Control
                    as="select"
                    name="retailerId"
                    value={filters.retailerId}
                    onChange={handleFilterChange}
                    style={{ height: "auto", minWidth: "180px" }}
                  >
                    <option value="">All</option>
                    {retailer?.map((ret) => (
                      <option key={ret.id} value={ret.id}>
                        {ret.companyName}
                      </option>
                    ))}
                  </RB.Form.Control>
                </RB.Col>
              )}

              <RB.Col xs="auto">
                <RB.Form.Label>Order Date</RB.Form.Label>
                <DatePicker
                  selectsRange
                  startDate={filters.orderDateRange[0]}
                  endDate={filters.orderDateRange[1]}
                  onChange={handleDateRangeChange}
                  isClearable
                  className="form-control"
                  placeholderText="Select date range"
                  dateFormat="yyyy-MM-dd"
                />
              </RB.Col>

              <RB.Col xs="auto">
                <RB.Form.Label>Status</RB.Form.Label>
                <RB.Form.Control
                  as="select"
                  name="status"
                  value={filters.status}
                  onChange={handleFilterChange}
                  style={{ height: "auto", minWidth: "200px" }}
                >
                  <option value="">All</option>
                  {statusOptions.map((status) => (
                    <option key={status.value} value={status.value}>
                      {status.label}
                    </option>
                  ))}
                </RB.Form.Control>
              </RB.Col>

              <RB.Col xs="auto" className="d-flex align-items-end">
                <RB.Button
                  variant="primary"
                  className="me-2"
                  onClick={() => {
                    setPage(1);
                    getOrder();
                  }}
                >
                  Find
                </RB.Button>
                <RB.Button
                  variant="secondary"
                  onClick={() => {
                    const clearedFilters = {
                      orderNo: "",
                      orderDateRange: [null, null],
                      status: "",
                      retailerId: "",
                    };
                    setFilters(clearedFilters);
                    setPage(1);
                    setReset(true);
                  }}
                >
                  Reset
                </RB.Button>
              </RB.Col>
            </RB.Row>

            <DataTable
              columns={columns}
              data={orderList?.result}
              highlightOnHover
              responsive
              pagination
              paginationServer
              paginationTotalRows={orderList?.total}
              paginationPerPage={countPerPage}
              paginationComponentOptions={{
                noRowsPerPage: true,
              }}
              paginationComponent={() => (
                <CustomPagination
                  currentPage={page}
                  totalRows={orderList?.total}
                  rowsPerPage={countPerPage}
                  onPageChange={handlePageChange}
                />
              )}
              striped
              onChangePage={(page) => setPage(page)}
              persistTableHead
              customStyles={{
                head: {
                  style: {
                    fontSize: "0.875rem", // Adjust the font size as needed
                    fontWeight: "bold", // Adjust the font weight as needed
                  },
                },
              }}
              // subHeader
              // subHeaderComponent={subHeaderComponent}
            />
          </RB.Card.Body>
        </RB.Card>
      </div>
    </>
  );
}

export default Listing;
